<template>
  <div>
    <div class="modal">
      <Spinner v-if="isLoadingData" :fullscreen="true">
        <template v-slot:header
          >Fetch prefix list of your ASN and prefixes</template
        >
        We are loading your data.
        <br />This may take a few seconds.</Spinner
      >
      <!-- for non-mobile -->
      <div v-if="!isMobile" class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="showConfirmModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="modal-body__left">
              <StepsRS
                :index="innerPageIndex"
                :isVisitedObj="isInnerPageVisitedObj"
                :isApplyBtnDisabled="isApplyBtnDisabled"
                :isSubmitBtnDisabled="isSubmitBtnDisabled"
                @changeStep="changeStep"
              ></StepsRS>
            </div>
            <div class="modal-body__right">
              <FilterRS
                v-if="innerPageIndex === 1"
                :prefixList="prefixList"
                :prevSelectedPrefixList="selectedPrefixList"
                :prevFilterType="filterType"
                :prevPrefixFilterType="prefixFilterType"
                :prevMatchType="matchType"
                :isInvalidInputWarningShown="isInvalidInputWarningShown"
                :prevSelectedASList="selectedASList"
                :prevASFilterType="ASFilterType"
                :isOriginASDisabled="isOriginASDisabled"
                @onUpdateSelectedPrefixList="updateSelectedPrefixList"
                @onFilterTypeChange="setFilterTypeChange"
                @onPrefixFilterTypeChange="setPrefixFilterType"
                @onMatchTypeChange="setMatchType"
                @onAddSubBlockIntoPrefixList="addSubBlockIntoPrefixList"
                @onASFilterTypeChange="setASFilterType"
                @onUpdateSelectedASList="updateSelectedASList"
              ></FilterRS>
              <TriggerRS
                v-if="innerPageIndex === 2"
                :triggerObj="triggerObj"
                :isBGPStatusDisabled="isBGPStatusDisabled"
                :isInvalidInputWarningShown="isInvalidInputWarningShown"
              ></TriggerRS>
              <ActionRS
                v-if="innerPageIndex === 3"
                :actionObj="actionObj"
                :isInvalidInputWarningShown="isInvalidInputWarningShown"
              ></ActionRS>
              <AlertNameRS
                v-if="innerPageIndex === 4"
                :alertName="alertName"
                @confirmInput="confirmAlertName"
              ></AlertNameRS>
            </div>
          </div>
          <div v-if="!isEditing" class="modal-footer">
            <button
              v-if="innerPageIndex > 1"
              type="button"
              class="btn btn-outline-primary"
              @click="innerPageIndex--"
            >
              Previous
            </button>
            <button
              v-if="innerPageIndex < 4"
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled }"
              @click="applyCurrentStepSetting"
            >
              Next
            </button>
            <button
              v-if="innerPageIndex === 4"
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled || isSubmitBtnDisabled }"
              @click="submit"
            >
              Submit
            </button>
          </div>
          <div v-else class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-primary"
              @click="showConfirmModal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled || isSubmitBtnDisabled }"
              @click="submit"
            >
              Save
            </button>
          </div>
        </div>
      </div>

      <!-- for mobile -->
      <div v-if="isMobile" id="mobile" class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeConfirmModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              v-if="innerPageIndex === 0 || isEditing"
              :class="{ 'nav-page': !isEditing, 'nav-tab': isEditing }"
            >
              <StepsRS
                :index="innerPageIndex"
                :isVisitedObj="isInnerPageVisitedObj"
                :isApplyBtnDisabled="isApplyBtnDisabled"
                :isSubmitBtnDisabled="isSubmitBtnDisabled"
                @changeStep="changeStep"
              ></StepsRS>
            </div>
            <FilterRS
              v-if="innerPageIndex === 1"
              :prefixList="prefixList"
              :prevSelectedPrefixList="selectedPrefixList"
              :prevFilterType="filterType"
              :prevPrefixFilterType="prefixFilterType"
              :prevMatchType="matchType"
              :isInvalidInputWarningShown="isInvalidInputWarningShown"
              :prevSelectedASList="selectedASList"
              :prevASFilterType="ASFilterType"
              :isOriginASDisabled="isOriginASDisabled"
              @onUpdateSelectedPrefixList="updateSelectedPrefixList"
              @onFilterTypeChange="setFilterTypeChange"
              @onPrefixFilterTypeChange="setPrefixFilterType"
              @onMatchTypeChange="setMatchType"
              @onAddSubBlockIntoPrefixList="addSubBlockIntoPrefixList"
              @onASFilterTypeChange="setASFilterType"
              @onUpdateSelectedASList="updateSelectedASList"
              @backToIndexPage="backToIndexPage"
            ></FilterRS>

            <TriggerRS
              v-if="innerPageIndex === 2"
              :triggerObj="triggerObj"
              :isBGPStatusDisabled="isBGPStatusDisabled"
              :isInvalidInputWarningShown="isInvalidInputWarningShown"
              @backToIndexPage="backToIndexPage"
            ></TriggerRS>
            <ActionRS
              v-if="innerPageIndex === 3"
              :actionObj="actionObj"
              :isInvalidInputWarningShown="isInvalidInputWarningShown"
              @backToIndexPage="backToIndexPage"
            ></ActionRS>
            <AlertNameRS
              v-if="innerPageIndex === 4"
              :alertName="alertName"
              @confirmInput="confirmAlertName"
              @backToIndexPage="backToIndexPage"
            ></AlertNameRS>
          </div>
          <div v-if="!isEditing && innerPageIndex !== 0" class="modal-footer">
            <button
              v-if="innerPageIndex > 0"
              type="button"
              class="btn btn-outline-primary"
              @click="innerPageIndex--"
            >
              Previous
            </button>
            <button
              v-if="innerPageIndex < 4"
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled }"
              @click="applyCurrentStepSetting"
            >
              Next
            </button>
            <button
              v-if="innerPageIndex === 4"
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled || isSubmitBtnDisabled }"
              @click="submit"
            >
              Submit
            </button>
          </div>
          <div v-else-if="isEditing" class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-primary"
              @click="showConfirmModal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :class="{ disabled: isApplyBtnDisabled || isSubmitBtnDisabled }"
              @click="submit"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--Confirm close modal -->
    <div v-if="isShowConfirmModal" class="modal confirm-close">
      <div class="modal-dialog" v-click-outside="continueEditing">
        <div class="modal-content">
          <div class="modal-header">
            Discard alert changes?
          </div>
          <div class="modal-body">The changes you made will be lost.</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click="continueEditing"
            >
              Continue editing
            </button>
            <button
              type="button"
              class="btn btn-outline-danger"
              @click="closeAlertModal"
            >
              Discard
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import * as vClickOutside from 'v-click-outside';
import isEqual from 'lodash.isequal';

import StepsRS from './StepsRS.vue';
import FilterRS from './FilterRS.vue';
import TriggerRS from './TriggerRS.vue';
import ActionRS from './ActionRS.vue';
import AlertNameRS from './AlertNameRS.vue';
import mixin from '../../../utils/mixin';
import Spinner from '../../ui/Spinner.vue';
import { checkIsValidSubBlock } from '../../../utils/ipAddressHelpers';
import {
  addClassModalOpenOnBody,
  removeClassModalOpenFromBody
} from '../../../utils/BOM';

import {
  FILTER_TYPE,
  AS_FILTER_TYPE,
  PREFIX_FILTER_TYPE,
  TRIGGER_TYPE,
  BGP_ANNOUNCEMENT_TYPE,
  SELECTED_ORIGIN_AS_TYPE,
  ACTION_CHANNEL_TYPE,
  EMAIL_RECIPIENT_TYPE,
  ROUTING_STATUS_ALERTS_REQUEST,
  MATCH_TYPE,
  ALIGNMENT_TYPE,
  RECIPIENT_TYPE_IN_API
} from '../../../constants/alertsRoutingStatusConstant';

export default {
  name: 'CreateAlertsRoutingStatusModal',
  components: { StepsRS, FilterRS, TriggerRS, ActionRS, AlertNameRS, Spinner },
  mixins: [mixin],
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    isEditing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerPageIndex: 0,
      isInnerPageVisitedObj: {
        1: true,
        2: false,
        3: false,
        4: false
      },
      selectedPrefixList: [],
      selectedASList: [],
      alertName: '',
      isShowConfirmModal: false,
      isValidAlertName: this.isEditing ? true : false,
      isPageIndexChanged: false,
      initialData: {},
      filterType: FILTER_TYPE.PREFIX,
      prefixFilterType: PREFIX_FILTER_TYPE.PREFIX_ANNOUNCED_BY_ASN,
      matchType: 0,
      ASFilterType: AS_FILTER_TYPE.AS_DELEGATED_TO_ACCOUNT,
      prefixList: [],
      isInvalidInputWarningShown: false,
      triggerObj: {
        triggerType: TRIGGER_TYPE.ROA_OR_ROUTE_OBJECT_ALIGNMENT,
        alignmentType: [
          ALIGNMENT_TYPE.MISMATCHED,
          ALIGNMENT_TYPE.NOT_PUBLISHED
        ],
        BGPAnnouncementType: BGP_ANNOUNCEMENT_TYPE.ROUTE_EXISTS,
        selectedOriginASType: SELECTED_ORIGIN_AS_TYPE.ANY_DELEGATED_TO_ACCOUNT,
        selectedOriginASList: []
      },
      actionObj: {
        isSendingAlertResolvedNotification: true,
        channelType: ACTION_CHANNEL_TYPE.EMAIL,
        recipientType: EMAIL_RECIPIENT_TYPE.MYSELF,
        recipientList: []
      }
    };
  },
  computed: {
    ...mapGetters('authStore', ['oidcUser']),
    ...mapGetters('dataStore', ['selectedAccount', 'asnList']),
    ...mapGetters('alertsRoutingStatusStore', [
      'delegatedPrefixListOfSelectedAccount'
    ]),
    ...mapState('alertsRoutingStatusStore', [
      'isLoadingData',
      'editingAlertObj',
      'isEditingAlert'
    ]),
    isApplyBtnDisabled() {
      const isInvalidMatchType =
        this.filterType === FILTER_TYPE.PREFIX &&
        this.prefixFilterType !== PREFIX_FILTER_TYPE.PREFIX_ANNOUNCED_BY_ASN &&
        this.matchType === 0;

      const isSelectedPrefixListEmpty =
        this.filterType === FILTER_TYPE.PREFIX &&
        this.prefixFilterType ===
          PREFIX_FILTER_TYPE.PREFIX_SELECTED_INDIVIDUALLY &&
        this.selectedPrefixList.length === 0;

      const isSelectedASListEmpty =
        this.filterType === FILTER_TYPE.AS &&
        this.ASFilterType === AS_FILTER_TYPE.AS_SELECTED_INDIVIDUALLY &&
        this.selectedASList.length === 0;

      const isInvalidTrigger =
        (this.innerPageIndex === 2 &&
          this.triggerObj.triggerType ===
            TRIGGER_TYPE.ROA_OR_ROUTE_OBJECT_ALIGNMENT &&
          this.triggerObj.alignmentType.length === 0) ||
        (this.innerPageIndex === 2 &&
          this.triggerObj.triggerType ===
            TRIGGER_TYPE.BGP_ANNOUNCEMENT_STATUS &&
          this.triggerObj.selectedOriginASType ===
            SELECTED_ORIGIN_AS_TYPE.INDIVIDUAL &&
          this.triggerObj.selectedOriginASList.length === 0);

      const isInvalidAction =
        this.innerPageIndex === 3 && this.actionObj.recipientList.length === 0;

      return (
        isInvalidMatchType ||
        isSelectedPrefixListEmpty ||
        isSelectedASListEmpty ||
        isInvalidTrigger ||
        isInvalidAction
      );
    },
    isSubmitBtnDisabled() {
      const isInvalidMatchType =
        this.filterType === FILTER_TYPE.PREFIX &&
        this.prefixFilterType !== PREFIX_FILTER_TYPE.PREFIX_ANNOUNCED_BY_ASN &&
        this.matchType === 0;

      const isSelectedPrefixListEmpty =
        this.filterType === FILTER_TYPE.PREFIX &&
        this.prefixFilterType ===
          PREFIX_FILTER_TYPE.PREFIX_SELECTED_INDIVIDUALLY &&
        this.selectedPrefixList.length === 0;

      const isSelectedASListEmpty =
        this.filterType === FILTER_TYPE.AS &&
        this.ASFilterType === AS_FILTER_TYPE.AS_SELECTED_INDIVIDUALLY &&
        this.selectedASList.length === 0;

      const isInvalidTrigger =
        (this.triggerObj.triggerType ===
          TRIGGER_TYPE.ROA_OR_ROUTE_OBJECT_ALIGNMENT &&
          this.triggerObj.alignmentType.length === 0) ||
        (this.triggerObj.triggerType === TRIGGER_TYPE.BGP_ANNOUNCEMENT_STATUS &&
          this.triggerObj.selectedOriginASType ===
            SELECTED_ORIGIN_AS_TYPE.INDIVIDUAL &&
          this.triggerObj.selectedOriginASList.length === 0);

      const isInvalidAction = this.actionObj.recipientList.length === 0;

      return (
        isInvalidMatchType ||
        isSelectedPrefixListEmpty ||
        isSelectedASListEmpty ||
        isInvalidTrigger ||
        isInvalidAction ||
        !this.isValidAlertName
      );
    },
    title() {
      return this.isEditing ? 'Edit alert' : 'Create alert';
    },
    isBGPStatusDisabled() {
      return this.filterType === FILTER_TYPE.AS;
    },
    isOriginASDisabled() {
      return (
        this.triggerObj.triggerType === TRIGGER_TYPE.BGP_ANNOUNCEMENT_STATUS
      );
    }
  },
  methods: {
    showConfirmModal() {
      const isDataChanged = this.checkIsDataChanged();

      if (isDataChanged) {
        this.isShowConfirmModal = true;
      } else {
        this.closeAlertModal();
      }
    },
    closeAlertModal() {
      this.isShowConfirmModal = false;
      this.$emit('closeModal');
    },
    continueEditing() {
      this.isShowConfirmModal = false;
    },
    submit() {
      if (this.isApplyBtnDisabled || this.isSubmitBtnDisabled) return;

      const filter = this.getFilterObj();
      const trigger = this.getTrigger();
      const action = this.getAction();
      const filterTrigger =
        this.filterType === FILTER_TYPE.PREFIX
          ? { prefix: { filter, trigger } }
          : { origin: { filter, trigger } };

      const alert = {
        memberId: parseInt(this.selectedAccount.id),
        name: this.alertName,
        alertOnResolve: this.actionObj.isSendingAlertResolvedNotification,
        filterTrigger,
        action
      };

      this.$emit('submitAlert', alert);
    },
    changeStep(stepId) {
      !this.isPageIndexChanged && (this.isPageIndexChanged = true);

      this.innerPageIndex = stepId;
    },
    applyCurrentStepSetting() {
      if (this.isApplyBtnDisabled) {
        this.isInvalidInputWarningShown = true;
        return;
      } else {
        this.innerPageIndex++;
        this.isInvalidInputWarningShown = false;
        this.isInnerPageVisitedObj[this.innerPageIndex] = true;
      }
    },
    updateSelectedPrefixList(val) {
      this.selectedPrefixList = val;
    },
    updateSelectedASList(val) {
      this.selectedASList = val;
    },
    setFilterTypeChange(val) {
      this.filterType = val;
    },
    setMatchType(val) {
      this.matchType = val;
    },
    setPrefixFilterType(val) {
      this.prefixFilterType = val;
    },
    setASFilterType(val) {
      this.ASFilterType = val;
    },

    backToIndexPage() {
      this.innerPageIndex = 0;
    },
    confirmAlertName({ alertName, isValidAlertName }) {
      this.alertName = alertName;
      this.isValidAlertName = isValidAlertName;
    },
    closeConfirmModal() {
      if (
        this.isMobile &&
        !this.isEditing &&
        this.innerPageIndex === 0 &&
        !this.isPageIndexChanged
      ) {
        // Close Alert modal directly when create modal on mobile devices and users have stayed on category page
        this.closeAlertModal();
      } else {
        this.showConfirmModal();
      }
    },
    checkIsDataChanged() {
      const currentData = {
        selectedPrefixList: [...this.selectedPrefixList],
        filterType: this.filterType,
        prefixFilterType: this.prefixFilterType,
        matchType: this.matchType,
        selectedASList: this.selectedASList,
        ASFilterType: this.ASFilterType,
        triggerObj: JSON.parse(JSON.stringify(this.triggerObj)),
        recipientList: JSON.parse(JSON.stringify(this.actionObj.recipientList)),
        alertName: this.alertName
      };

      const isDataChanged = !isEqual(currentData, this.initialData);

      return isDataChanged;
    },
    addSubBlockIntoPrefixList(subBlock) {
      this.prefixList.unshift(subBlock);
    },
    getFilterObj() {
      if (this.filterType === FILTER_TYPE.PREFIX) {
        let prefixes = {};
        let matchType = '';
        switch (this.matchType) {
          case MATCH_TYPE.EXACT_ONLY:
            matchType = ROUTING_STATUS_ALERTS_REQUEST.exactOrMoreSpecific.exact;
            break;
          case MATCH_TYPE.MORE_SPECIFIC_ONLY:
            matchType =
              ROUTING_STATUS_ALERTS_REQUEST.exactOrMoreSpecific.moreSpecific;
            break;
          case MATCH_TYPE.EXACT_OR_MORE_SPECIFIC:
            matchType =
              ROUTING_STATUS_ALERTS_REQUEST.exactOrMoreSpecific
                .exactAndMoreSpecific;
            break;
          default:
            matchType =
              ROUTING_STATUS_ALERTS_REQUEST.exactOrMoreSpecific
                .exactAndMoreSpecific;
            break;
        }

        switch (this.prefixFilterType) {
          case PREFIX_FILTER_TYPE.PREFIX_SELECTED_INDIVIDUALLY:
            prefixes = {
              individualPrefixes: this.selectedPrefixList
            };
            break;
          case PREFIX_FILTER_TYPE.PREFIX_ANNOUNCED_BY_ASN:
            prefixes =
              ROUTING_STATUS_ALERTS_REQUEST.prefixFilter.anyPrefixInMyOrigins;
            break;
          case PREFIX_FILTER_TYPE.PREFIX_DELEGATED_TO_ACCOUNT:
            prefixes =
              ROUTING_STATUS_ALERTS_REQUEST.prefixFilter.myAccountPrefixes;
            break;
          default:
            break;
        }

        return { prefixes, matchType };
      } else if (this.filterType === FILTER_TYPE.AS) {
        if (this.ASFilterType === AS_FILTER_TYPE.AS_DELEGATED_TO_ACCOUNT) {
          return ROUTING_STATUS_ALERTS_REQUEST.originAsFilter
            .allOriginsInMyAccount;
        } else if (
          this.ASFilterType === AS_FILTER_TYPE.AS_SELECTED_INDIVIDUALLY
        ) {
          const individualOrigins = this.selectedASList.map(item =>
            Number(item.replace(/^AS/i, ''))
          );
          return { individualOrigins };
        }
      }
    },
    getTrigger() {
      if (
        this.triggerObj.triggerType ===
        TRIGGER_TYPE.ROA_OR_ROUTE_OBJECT_ALIGNMENT
      ) {
        const isAlignmentMismatch = this.triggerObj.alignmentType.includes(
          ALIGNMENT_TYPE.MISMATCHED
        );
        const isAlignmentNotPublished = this.triggerObj.alignmentType.includes(
          ALIGNMENT_TYPE.NOT_PUBLISHED
        );
        return {
          roa: {
            mismatch: isAlignmentMismatch,
            notPublished: isAlignmentNotPublished
          }
        };
      } else if (
        this.triggerObj.triggerType === TRIGGER_TYPE.BGP_ANNOUNCEMENT_STATUS
      ) {
        let announcementStatus = '';
        switch (this.triggerObj.BGPAnnouncementType) {
          case BGP_ANNOUNCEMENT_TYPE.ROUTE_EXISTS:
            announcementStatus =
              ROUTING_STATUS_ALERTS_REQUEST.bgpAnnouncementStatus.routeExists;
            break;
          case BGP_ANNOUNCEMENT_TYPE.ROUTE_NOT_EXISTS:
            announcementStatus =
              ROUTING_STATUS_ALERTS_REQUEST.bgpAnnouncementStatus
                .routeDoesntExist;
            break;
          default:
            break;
        }

        let originAs = null;

        if (
          this.triggerObj.selectedOriginASType ===
          SELECTED_ORIGIN_AS_TYPE.ANY_DELEGATED_TO_ACCOUNT
        ) {
          originAs =
            ROUTING_STATUS_ALERTS_REQUEST.bgpOriginAs.anyOriginDelegated;
        } else if (
          this.triggerObj.selectedOriginASType ===
          SELECTED_ORIGIN_AS_TYPE.ANY_NOT_DELEGATED_TO_ACCOUNT
        ) {
          originAs =
            ROUTING_STATUS_ALERTS_REQUEST.bgpOriginAs.anyOriginNotDelegated;
        } else if (
          this.triggerObj.selectedOriginASType ===
          SELECTED_ORIGIN_AS_TYPE.INDIVIDUAL
        ) {
          const individualOrigins = this.triggerObj.selectedOriginASList.map(
            item => Number(item.replace(/^AS/i, ''))
          );
          originAs = { individualOrigins };
        }

        return {
          bgp: {
            announcementStatus,
            originAs
          }
        };
      }
    },
    getAction() {
      const action = this.actionObj.recipientList.map(item => {
        let channel = '';
        let recipient = {};

        switch (item.channel) {
          case ACTION_CHANNEL_TYPE.EMAIL:
            channel = ROUTING_STATUS_ALERTS_REQUEST.channel.email;
            break;
          case ACTION_CHANNEL_TYPE.SMS:
            channel = ROUTING_STATUS_ALERTS_REQUEST.channel.sms;
            break;
          case ACTION_CHANNEL_TYPE.SLACK:
            channel = ROUTING_STATUS_ALERTS_REQUEST.channel.slack;
            break;
          default:
            break;
        }

        if (item.recipientType === RECIPIENT_TYPE_IN_API.APNIC_USER) {
          recipient = { apnicUser: item.recipientValue };
        } else if (
          item.recipientType === RECIPIENT_TYPE_IN_API.NON_APNIC_USER
        ) {
          recipient = { nonApnicUser: item.recipientValue };
        }

        return { channel, recipient };
      });

      return action;
    }
  },
  mounted() {
    // Prevent background page from scrolling when the modal is open.
    addClassModalOpenOnBody();

    // Close modal with 'esc' key
    document.addEventListener('keydown', e => {
      if (e.code == 'Escape') {
        if (this.isShowConfirmModal) {
          this.continueEditing();
        } else {
          this.showConfirmModal();
        }
      }
    });

    this.prefixList = this.delegatedPrefixListOfSelectedAccount;

    this.innerPageIndex = this.isMobile && !this.isEditing ? 0 : 1;

    // If in edit mode, preset Alert config
    if (this.isEditing) {
      const {
        filterTrigger,
        alertOnResolve,
        action,
        name
      } = this.editingAlertObj;

      let trigger = null;

      // Init filter and trigger step when edit alert
      if (filterTrigger) {
        if (filterTrigger.prefix) {
          this.filterType = FILTER_TYPE.PREFIX;
          trigger = filterTrigger.prefix.trigger;
          const { filter } = filterTrigger.prefix;

          if (
            filter.prefixes ===
            ROUTING_STATUS_ALERTS_REQUEST.prefixFilter.anyPrefixInMyOrigins
          ) {
            this.prefixFilterType = PREFIX_FILTER_TYPE.PREFIX_ANNOUNCED_BY_ASN;
          } else if (
            filter.prefixes ===
            ROUTING_STATUS_ALERTS_REQUEST.prefixFilter.myAccountPrefixes
          ) {
            this.prefixFilterType =
              PREFIX_FILTER_TYPE.PREFIX_DELEGATED_TO_ACCOUNT;
          } else if (filter.prefixes && filter.prefixes.individualPrefixes) {
            this.prefixFilterType =
              PREFIX_FILTER_TYPE.PREFIX_SELECTED_INDIVIDUALLY;

            // Set this.selectedPrefixList by checking whether each prefix in filter.prefix.individualPrefixes.prefixes is a sub-block (equal is a certain case of sub-block) of any prefix in this.prefixList
            this.selectedPrefixList = filter.prefixes.individualPrefixes.filter(
              item => checkIsValidSubBlock(item, this.prefixList)
            );

            // Add prefix into this.prefixList, which is a sub-block (not including equal) of any prefix in this.prefixList
            this.prefixList = [
              ...new Set([...this.selectedPrefixList, ...this.prefixList])
            ];
          }

          if (filter.matchType) {
            switch (filter.matchType) {
              case ROUTING_STATUS_ALERTS_REQUEST.exactOrMoreSpecific.exact:
                this.matchType = MATCH_TYPE.EXACT_ONLY;
                break;
              case ROUTING_STATUS_ALERTS_REQUEST.exactOrMoreSpecific
                .moreSpecific:
                this.matchType = MATCH_TYPE.MORE_SPECIFIC_ONLY;
                break;
              case ROUTING_STATUS_ALERTS_REQUEST.exactOrMoreSpecific
                .exactAndMoreSpecific:
                this.matchType = MATCH_TYPE.EXACT_OR_MORE_SPECIFIC;
                break;
              default:
                break;
            }
          }
        } else if (filterTrigger.origin) {
          this.filterType = FILTER_TYPE.AS;
          trigger = filterTrigger.origin.trigger;
          const { filter } = filterTrigger.origin;

          if (
            filter ===
            ROUTING_STATUS_ALERTS_REQUEST.originAsFilter.allOriginsInMyAccount
          ) {
            this.ASFilterType = AS_FILTER_TYPE.AS_DELEGATED_TO_ACCOUNT;
          } else if (filter.individualOrigins) {
            this.ASFilterType = AS_FILTER_TYPE.AS_SELECTED_INDIVIDUALLY;

            const formattedAsnList = this.asnList.map(item => Number(item.id));

            this.selectedASList = filter.individualOrigins
              .filter(item => formattedAsnList.includes(item))
              .map(item => `AS${item}`);
          }
        }
      }

      // Init trigger step when edit alert
      if (trigger) {
        this.triggerObj.triggerType =
          TRIGGER_TYPE.ROA_OR_ROUTE_OBJECT_ALIGNMENT;

        if (trigger.roa) {
          const { mismatch, notPublished } = trigger.roa;

          if (mismatch) {
            this.triggerObj.alignmentType = [ALIGNMENT_TYPE.MISMATCHED];
          } else {
            this.triggerObj.alignmentType = [];
          }

          if (notPublished) {
            this.triggerObj.alignmentType.push(ALIGNMENT_TYPE.NOT_PUBLISHED);
          }
        } else if (trigger.bgp) {
          this.triggerObj.triggerType = TRIGGER_TYPE.BGP_ANNOUNCEMENT_STATUS;

          const { announcementStatus, originAs } = trigger.bgp;

          if (
            announcementStatus ===
            ROUTING_STATUS_ALERTS_REQUEST.bgpAnnouncementStatus.routeExists
          ) {
            this.triggerObj.BGPAnnouncementType =
              BGP_ANNOUNCEMENT_TYPE.ROUTE_EXISTS;
          } else if (
            announcementStatus ===
            ROUTING_STATUS_ALERTS_REQUEST.bgpAnnouncementStatus.routeDoesntExist
          ) {
            this.triggerObj.BGPAnnouncementType =
              BGP_ANNOUNCEMENT_TYPE.ROUTE_NOT_EXISTS;
          }

          if (
            originAs ===
            ROUTING_STATUS_ALERTS_REQUEST.bgpOriginAs.anyOriginDelegated
          ) {
            this.triggerObj.selectedOriginASType =
              SELECTED_ORIGIN_AS_TYPE.ANY_DELEGATED_TO_ACCOUNT;
          } else if (
            originAs ===
            ROUTING_STATUS_ALERTS_REQUEST.bgpOriginAs.anyOriginNotDelegated
          ) {
            this.triggerObj.selectedOriginASType =
              SELECTED_ORIGIN_AS_TYPE.ANY_NOT_DELEGATED_TO_ACCOUNT;
          } else if (originAs.individualOrigins) {
            this.triggerObj.selectedOriginASType =
              SELECTED_ORIGIN_AS_TYPE.INDIVIDUAL;
            this.triggerObj.selectedOriginASList = originAs.individualOrigins.map(
              item => `AS${item}`
            );
          }
        }
      }

      // Init action step when edit alert
      if (action) {
        this.actionObj.isSendingAlertResolvedNotification = alertOnResolve;

        this.actionObj.recipientList = action.map(item => {
          if (item.channel === ROUTING_STATUS_ALERTS_REQUEST.channel.email) {
            if (item.recipient.apnicUser) {
              return {
                channel: ACTION_CHANNEL_TYPE.EMAIL,
                recipientType: RECIPIENT_TYPE_IN_API.APNIC_USER,
                recipientValue: item.recipient.apnicUser
              };
            } else if (item.recipient.nonApnicUser) {
              return {
                channel: ACTION_CHANNEL_TYPE.EMAIL,
                recipientType: RECIPIENT_TYPE_IN_API.NON_APNIC_USER,
                recipientValue: item.recipient.nonApnicUser
              };
            }
          } else if (
            item.channel === ROUTING_STATUS_ALERTS_REQUEST.channel.sms
          ) {
            return {
              channel: ACTION_CHANNEL_TYPE.SMS,
              recipientType: RECIPIENT_TYPE_IN_API.NON_APNIC_USER,
              recipientValue: item.recipient.nonApnicUser
            };
          } else if (
            item.channel === ROUTING_STATUS_ALERTS_REQUEST.channel.slack
          ) {
            return {
              channel: ACTION_CHANNEL_TYPE.SLACK,
              recipientType: RECIPIENT_TYPE_IN_API.NON_APNIC_USER,
              recipientValue: item.recipient.nonApnicUser
            };
          }
        });
      }

      // Init name step when edit alert
      this.alertName = name;
    }

    // Set initialData to check if any data is changed when close modal
    this.initialData = {
      selectedPrefixList: [...this.selectedPrefixList],
      filterType: this.filterType,
      prefixFilterType: this.prefixFilterType,
      matchType: this.matchType,
      selectedASList: this.selectedASList,
      ASFilterType: this.ASFilterType,
      triggerObj: JSON.parse(JSON.stringify(this.triggerObj)),
      recipientList: JSON.parse(JSON.stringify(this.actionObj.recipientList)),
      alertName: this.alertName
    };
  },

  beforeDestroy() {
    // Allow background page to scroll when the modal is closed.
    removeClassModalOpenFromBody();
  }
};
</script>

<style lang="scss" scoped>
.modal {
  z-index: 1030;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);
}

.modal-dialog {
  max-width: initial;
  width: 80%;
}

.modal-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  h5 {
    height: 2.375rem;
    line-height: 2.375rem;
  }

  .close {
    font-size: 2rem;
  }

  &__left {
    flex: 1;
  }

  &__right {
    flex: 2;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;

    & > span {
      font-weight: 600;
    }
  }
}

.modal-body {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 0;
  height: 70vh;

  &.disabled-mask::before {
    @include disabled-mask;
  }

  &__left {
    width: 30%;
  }

  &__right {
    width: 70%;
  }
}

.modal-footer {
  position: relative;

  &.disabled-mask::before {
    @include disabled-mask;
  }

  .disabled {
    // pointer-events: none;
    cursor: not-allowed;
  }
}

#mobile {
  &.modal-dialog {
    width: 100vw;
    height: 100%;
    margin: 0;
  }

  .modal-content {
    height: 100%;
  }

  .modal-header {
    height: 3rem;
    line-height: 3rem;
    background-color: $text-light-blue;

    h5 {
      line-height: 1;
      color: #fff;
    }

    button {
      margin: -1.5rem -0.5rem 0 0;
      padding: 1rem;
      color: #fff;
      opacity: 1;
      font-size: 2rem;
    }
  }

  .modal-body {
    flex-direction: column;

    &.disabled-mask::before {
      @include disabled-mask;
      top: 5rem;
    }

    .nav-page {
      height: 100%;
      padding-top: 1.5rem;
      background-color: $background-grey;

      & > span {
        padding: 0 1rem;
        font-weight: 600;
      }
    }
  }

  .modal-footer {
    justify-content: space-evenly;
  }
}

.confirm-close.modal {
  z-index: 1031;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);

  .modal-dialog {
    max-width: initial;
    width: 40%;
    min-width: 22rem;
    max-width: 28rem;
  }

  .modal-header {
    font-weight: 600;
    padding-top: 1rem;
  }

  .modal-body {
    height: 4rem;
    padding: 1rem;
  }

  .modal-footer {
    justify-content: space-evenly;
  }
}
</style>
